<form [bitSubmit]="singleStepSubmit" [formGroup]="formGroup">
  <bit-form-field>
    <bit-label>{{ "emailAddress" | i18n }}</bit-label>
    <input
      id="email"
      type="email"
      formControlName="email"
      bitInput
      appAutofocus
      [placeholder]="'emailAddress' | i18n"
      data-testid="login-email-input"
      (input)="onEmailInput($event)"
    />
  </bit-form-field>

  <bit-form-field class="!tw-mb-1">
    <bit-label>{{ "masterPass" | i18n }}</bit-label>
    <input
      id="masterPassword"
      type="password"
      autocomplete="current-password"
      formControlName="masterPassword"
      bitInput
      [placeholder]="'masterPass' | i18n"
      data-testid="login-master-password-input"
    />
    <button type="button" bitIconButton bitSuffix bitPasswordInputToggle></button>
  </bit-form-field>

  <bit-form-control class="tw-mb-6">
    <input
      type="checkbox"
      formControlName="rememberEmail"
      data-testid="login-remember-email"
      (input)="onRememberEmailInput($event)"
      bitCheckbox
    />
    <bit-label>{{ "rememberEmail" | i18n }}</bit-label>
  </bit-form-control>

  <button
    type="submit"
    bitButton
    bitFormButton
    block
    buttonType="primary"
    class="brackets-auth-primary-button"
    data-testid="login-submit-button"
  >
    {{ "logIn" | i18n }}
  </button>

  <div class="tw-text-center tw-mt-4" *ngIf="!(isUserRegistrationDisabled$ | async)">
    {{ "newToBitwarden" | i18n }}
    <a bitLink routerLink="/signup" data-testid="login-create-account-link">{{
      "createAccount" | i18n
    }}</a>
  </div>

  <!-- Temporarily disabled: passkey and SSO login options
  <div class="tw-text-center tw-mt-3">{{ "or" | i18n }}</div>
  <button type="button" bitButton block buttonType="secondary" (click)="handleLoginWithPasskeyClick()">
    {{ "logInWithPasskey" | i18n }}
  </button>
  <button type="button" bitButton block buttonType="secondary" (click)="handleSsoClick()">
    {{ "useSingleSignOn" | i18n }}
  </button>
  -->
</form>
